import { render, staticRenderFns } from "./BlogDetailsTopBackground.vue?vue&type=template&id=1cf7df20&scoped=true&"
import script from "./BlogDetailsTopBackground.vue?vue&type=script&lang=js&"
export * from "./BlogDetailsTopBackground.vue?vue&type=script&lang=js&"
import style0 from "./BlogDetailsTopBackground.vue?vue&type=style&index=0&id=1cf7df20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf7df20",
  null
  
)

export default component.exports